/**
 * @generated SignedSource<<0fc77f10dc6413d039a52c47b36e164a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_issueResults$data = {
  readonly __id: string;
  readonly issueNavigatorPageInfo?: {
    readonly firstIssuePosition: number | null | undefined;
  } | null | undefined;
  readonly pageCursors?: {
    readonly around: ReadonlyArray<{
      readonly isCurrent: boolean | null | undefined;
      readonly pageNumber: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_issues" | "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions" | "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber">;
  readonly " $fragmentType": "main_issueNavigator_ListView_issueResults";
};
export type main_issueNavigator_ListView_issueResults$key = {
  readonly " $data"?: main_issueNavigator_ListView_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallbeyondfastfollowsrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_issueResults",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isReparentingEnabled",
          "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        {
          "kind": "Variable",
          "name": "shouldQueryHasChildren",
          "variableName": "shouldQueryHasChildren"
        }
      ],
      "kind": "FragmentSpread",
      "name": "NativeIssueTableWithSelectedIssuesProvider_issues"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallbeyondfastfollowsrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "maxCursors",
              "value": 7
            }
          ],
          "concreteType": "JiraPageCursors",
          "kind": "LinkedField",
          "name": "pageCursors",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraPageCursor",
              "kind": "LinkedField",
              "name": "around",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "pageNumber"
                },
                {
                  "kind": "ScalarField",
                  "name": "isCurrent"
                }
              ]
            }
          ],
          "storageKey": "pageCursors(maxCursors:7)"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallbeyondfastfollowsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueNavigatorPageInfo",
          "kind": "LinkedField",
          "name": "issueNavigatorPageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "firstIssuePosition"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "e836e4d1bc64c9cf49ac4930e417acb5";

export default node;
